import AnimatedEllipsis from './AnimatedEllipsis'

export default function AppLoadingView() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100dvh',
        background: 'var(--bg)',
        fontFamily: 'var(--font)',
        color: 'var(--text-muted)',
        fontSize: '14px',
        letterSpacing: '0.02em',
      }}
    >
      <span>Loading jontha assistant</span>
      <span
        style={{
          display: 'inline-flex',
          fontSize: '10px',
          letterSpacing: '3px',
          marginLeft: '4px',
          alignItems: 'center',
        }}
      >
        <AnimatedEllipsis />
      </span>
    </div>
  )
}
